import clsx from 'clsx';
import { format, parse } from 'date-fns';
import { type ReactElement } from 'react';
import { Text } from 'react-aria-components';
import { useTranslation } from 'react-i18next';
import type { NearestSlot } from '@provider-directory/components/availability/availability.model';

export interface LocationSelectorAdditionalInfoProps {
  nearestSlot?: NearestSlot;
}

export const LocationSelectorAdditionalInfo = ({
  nearestSlot,
}: LocationSelectorAdditionalInfoProps): ReactElement => {
  const { t } = useTranslation();

  let formattedDate: string | null = null;
  try {
    formattedDate = nearestSlot
      ? format(parse(nearestSlot.date, 'yyyy-MM-dd', new Date()), 'MMM d')
      : null;
  } catch {
    formattedDate = nearestSlot ? nearestSlot.date : null;
  }

  return (
    <Text className={clsx(nearestSlot ? 'text-green-600' : 'text-neutral-500')}>
      {nearestSlot
        ? t('schedule.nApptsAvailableOn', {
            count: nearestSlot.slotsCount,
            date: formattedDate,
          })
        : t('schedule.noOnlineAppointments')}
    </Text>
  );
};
